<template>
    <span class="timesheet-report-links" :class="{'timesheet-report-links--stacked': stacked, 'timesheet-report-links--compact': compact}">
        <router-link v-for="id in reportIds" :key="id"
                     :to="{name: 'report-card', params: {id}}"
                     target="_blank" rel="noopener noreferrer"
                     :aria-label="`Открыть отчёт №${id} в новой вкладке`"
                     @click.native.stop @pointerdown.native.stop @mousedown.native.stop>
            <span>{{ id }}</span>
        </router-link>
        <span v-if="!reportIds.length" aria-label="Нет отчётов">—</span>
    </span>
</template>

<script>
import {normalizeReportIds} from '@/utils/timesheetReportLinks';

export default {
    name: 'TimesheetReportLinks',
    props: {
        ids: {type: Array, default: () => []},
        stacked: {type: Boolean, default: false},
        compact: {type: Boolean, default: false}
    },
    computed: {
        reportIds() { return normalizeReportIds(this.ids); }
    }
};
</script>

<style scoped>
.timesheet-report-links {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 2px 6px;
    max-width: 100%;
    vertical-align: middle;
}
.timesheet-report-links a {
    min-width: 0;
    color: #1668a8;
    font-weight: 500;
    text-decoration: underline;
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
}
.timesheet-report-links a:focus-visible { outline: 2px solid #1683ff; outline-offset: 1px; }
.timesheet-report-links--stacked {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    gap: 2px;
    font-size: 9px;
    line-height: 1.2;
    text-align: center;
}
.timesheet-report-links--stacked a {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 24px;
}
.timesheet-report-links--stacked a > span {
    min-width: 0;
    max-width: 100%;
}
@media (pointer: coarse) {
    .timesheet-report-links a { padding: 4px 0; }
    .timesheet-report-links--stacked a { min-height: 28px; }
}
.timesheet-report-links--compact {
    justify-content: center;
    gap: 0 5px;
    font-size: 11px;
    line-height: 20px;
    font-variant-numeric: tabular-nums;
}
.timesheet-report-links--compact a {
    min-height: 20px;
    padding: 0;
    white-space: nowrap;
    overflow-wrap: normal;
    word-break: normal;
}
</style>
